























import Vue from 'vue'

export default Vue.extend({
  props: {
    filters: {
      type: Array,
      default: () => [],
    },
    selectedFilter: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    buttonWidth() {
      return `${100 / this.filters.length}%`
    },
  },
})
